<template lang="pug">
transition(name="fade")
  .smart-modal(v-show="dialog" @click="close")
    transition(name="magic")
      .smart-modal__content(v-if="dialog" @click.stop.prevent)
        v-card(width="400px" dark flat)
          component(
            :is="type ? 'v-alert' : 'div'"
            :color="type"
            text
            height="100%"
          ).pa-4.mb-0
            slot(name="title" v-bind="{ close }")
              .d-flex
                p.title.mr-auto {{ title }}
                v-btn.rounded(@click="close" text fab x-small)
                  v-icon mdi-close
            slot

            slot(name="actions" v-bind="{ close, confirm }")
              .d-flex(style="gap:10px").flex-wrap
                v-btn.flex-grow-1(@click="confirm" :color="type || 'success'") Ок
                v-btn.flex-grow-1(@click="close" text) Отменить

</template>

<script>
export default {
  currentPopupController: null,

  props:{
    title: { type: String, required: false, default: 'Подтверждение действия' },
    type: { type: String, required:false, default: '' },

  },
  data() {
    return { dialog: false };
  },

  watch:{
    dialog(v) {
      if (v) {
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.handleKeydown);
      } else {
        document.documentElement.style.overflow = 'auto';
        document.removeEventListener('keydown', this.handleKeydown);
      }
    },
  },

  methods: {
    handleKeydown(e) {
      if (this.dialog) {
        if (e.key === 'Escape') {
          this.close();
        }

        if (e.key === 'Enter') {
          this.confirm();
        }
      }
    },

    open() {
      let resolve;
      let reject;

      const popupPromise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });

      this.$options.popupController = { resolve, reject };

      this.dialog = true;

      return popupPromise;
    },

    confirm() {
      this.$options.popupController.resolve(true);
      this.dialog = false;
    },

    close() {
      this.$options.popupController.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss">
.smart-modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  z-index: 100;

  background-color: rgba(0, 0, 0, 0.8);

  &__content {
    position: fixed;
    height: 100%;
    display: flex;
    width: 100%;

    align-items: center;
    justify-content: center;
  }
}

.magic-enter-active {
  animation: bounce-in .5s;
}

.magic-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: translateY(-20px) perspective( 600px ) rotateX( 10deg );
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0) perspective( 600px ) rotateX( 0 );
  }
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

</style>
